import styled from 'styled-components';

const Profile1 = [
  '트랜스파머(주), 땅집고옥션, 엔플랫폼 CEO',
  '한양대학교 스마트시티공학과 겸임교수',
  '한림국제대학원대학교 MBA 주임교수',
  '삼정KPMG 전략컨설팅본부 이사',
  '삼성 오픈타이드 시니어매니저',
  '행안부 주소혁신포럼 위원',
  '인천경제자유구역청 비전/전략 위원',
];

const Profile2 = [
  '땅집고옥션, 엔플랫폼 CSO',
  '(주)바른엔피엘대부 의장',
  '(주)어썸컨설팅 대표',
  '전주대학교 부동산국토정보학과 객원교수',
  '법률사무소 글 자문위원',
];

function Instructor() {
  return (
    <Container>
      <Card>
        <Img1
          src="/assets/images/promotion/seminar/instructor1.png"
          alt="img1"
        />
        <CardHeader>
          <Name>김기현 대표</Name>
          <InstructorDesc>땅집고옥션 연구소장</InstructorDesc>
        </CardHeader>
        <ProfileContainer>
          <ProfileBadge>약력</ProfileBadge>
          {Profile1.map((item, idx) => (
            <Profile key={idx}>{item}</Profile>
          ))}
        </ProfileContainer>
      </Card>
      <Card2>
        <CardHeader>
          <Name>안영효 대표</Name>
          <InstructorDesc>엔플랫폼 CSO</InstructorDesc>
        </CardHeader>
        <ProfileContainer>
          <ProfileBadge>약력</ProfileBadge>
          {Profile2.map((item, idx) => (
            <Profile key={idx}>{item}</Profile>
          ))}
        </ProfileContainer>
        <Img2
          src="/assets/images/promotion/seminar/instructor2.png"
          alt="img1"
        />
      </Card2>
    </Container>
  );
}

export default Instructor;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 21px;
  align-self: stretch;
`;

const Card = styled.div`
  position: relative;

  display: flex;
  height: 762px;
  padding: 40px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  border-radius: 20px;
  background: #1e1e1e;
`;

const Card2 = styled(Card)`
  padding: 40px;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;

const Name = styled.div`
  color: #0ca8b1;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const InstructorDesc = styled.div`
  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;

const ProfileBadge = styled.div`
  display: flex;
  padding: 2px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #fff;

  color: #0ca8b1;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const Profile = styled.div`
  color: #fff;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.3px;
`;

const Img1 = styled.img`
  width: 307px;
  height: 412px;
  aspect-ratio: 38/51;
  position: absolute;
  bottom: -1px;
  left: 0;
`;

const Img2 = styled.img`
  width: 314px;
  height: 403px;
  aspect-ratio: 60/77;
  position: absolute;
  right: 0.5px;
  bottom: 0;
`;
